class Quote {
  constructor(contentfulNode) {
    this.avatarData = {
      fluid: contentfulNode?.avatar?.gatsbyImageData,
      title: contentfulNode?.avatar?.title
    }
    this.author = contentfulNode?.author;
    this.authorSubtitle = contentfulNode?.authorSubtitle;
    this.client = contentfulNode?.client;
    this.quote = contentfulNode?.quote?.quote;
    this.imageData = {
      fluid: contentfulNode?.image?.gatsbyImageData,
      title: contentfulNode?.image?.title
    }
    this.type = contentfulNode?.internal?.type;
  }
}

export default Quote;
